import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    dbFileId : "6dabb135-424d-4630-bd15-04c048db5d4e",
    key: "ca6aca0f1557ca09283d9ffb6d5c2305",
    loaded: false,
    processando : false,
    textoProcessamento : "",
    version: 0,
    registros : [],
    dbs : {},
    dbsToSave : []
}

export function novoDB(nome, timer, atribute, cb) {
    return { nome, timer, atribute, cb, modificationId : null, loaded : false, version: 0}
} 

// Alterações e verificações são feitas no proprio Store.js
export const dbsSlice = createSlice({
    name: "dbs",
    initialState,
    reducers: {
        registerDB : (state, action) => {
            // console.log("register", action)
            state.dbs[action.payload.nome] = action.payload
        },
        triggerDbVerification : () => {},
        triggerLoadNovoDB : () => {},
        defineAttrDB : (state, action) => {
            state[action.payload.campo] = action.payload.value
        },
        adicionaRegistro : (state, action) => {
            var r = [...state.registros]
            r.push(action.payload)
            state.registros = r
        },
        changeDBattr : (state, action) => {
            state.dbs[action.payload.nome][action.payload.campo] = action.payload.value
        },
        addDBtoSave: (state, action) => {
            var dbsToSave = [...state.dbsToSave]
            dbsToSave.push(action.payload)
            state.dbsToSave = dbsToSave
        },
        unloadDb: (state, action) => {
            delete state.dbs[action.payload]
        },
        triggerDBUploader : () => {}
    }
})

export const {
    registerDB,
    triggerDbVerification,
    triggerLoadNovoDB,
    defineAttrDB,
    adicionaRegistro,
    changeDBattr,
    addDBtoSave,
    triggerDBUploader,
    unloadDb
} = dbsSlice.actions



export default dbsSlice.reducer;